module.exports = __webpack_public_path__ + "static/img/10.a63537f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/10.jpg
// module id = aSLE
// module chunks = 1